import { Component } from '@angular/core';

@Component({
  selector: 'app-calendar-x-icon',
  imports: [],
  templateUrl: './calendar-x-icon.component.html',
  standalone: true
})
export class CalendarXIconComponent {}
